import DvpMatrixColumn from './DvpMatrixColumn';
import DvpMatrixRow from './DvpMatrixRow';

export default class DvpMatrixConfig {
    id: string;
    columns: DvpMatrixColumn[];
    rows: DvpMatrixRow[];
    instrumentIds: string[];
}